import i18next from "i18next";

/**
 * Global translation helper for non-React contexts (Redux slices, utils, plain modules).
 * React components that already use useTranslation() can still use their local `t`.
 */
export const t = (key, options = {}) =>
  i18next.t(key, {
    ns: "global",
    ...options,
  });

